/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ECaseStatus = 'UnSent' | 'NewUnAssigned' | 'Pending' | 'Repairing' | 'Delayed' | 'PaymentWaiting' | 'Finished' | 'Returned' | 'Received' | 'Closed' | 'InRepairing' | 'All';

export const ECaseStatus = {
    UnSent: 'UnSent' as ECaseStatus,
    NewUnAssigned: 'NewUnAssigned' as ECaseStatus,
    Pending: 'Pending' as ECaseStatus,
    Repairing: 'Repairing' as ECaseStatus,
    Delayed: 'Delayed' as ECaseStatus,
    PaymentWaiting: 'PaymentWaiting' as ECaseStatus,
    Finished: 'Finished' as ECaseStatus,
    Returned: 'Returned' as ECaseStatus,
    Received: 'Received' as ECaseStatus,
    Closed: 'Closed' as ECaseStatus,
    InRepairing: 'InRepairing' as ECaseStatus,
    All: 'All' as ECaseStatus
};

